<template>
   <div>
    <policy
      v-if="setForm"
      :dialog="setForm"
      :groups="policyGroups"
      :videoIDs="videoIDs"
      :can-create-group="hasGroupAccess"
      @onChange="createPolicy"
      @closed="closePolicy"
      @close="closePolicy"
      @create-group-request="handleCreateGroup"
    />
    <delete v-if="onDeleteDialog" :dialog="onDeleteDialog" :title="'Delete Policy'" :message="'Are you sure you want to delete this policy?'" :id="deleteID" @onChange="deleteConfirmation" @close="closeDelete"/>
    <policy-review v-if="showPolicyReview" :dialog="showPolicyReview" :policy="reviewedPolicy" @close="closePolicyReview" @closed="closePolicyReview" @onReviewDateChange="setNextReviewDate" @uploadNewVersion="uploadNewVersion"/>
    <policy-require v-if="showRequiredPopup" :dialog="showRequiredPopup" :policy="reviewedPolicy" @close="closePolicyRequire" @closed="closePolicyRequire" @onChange="preparePolicyRequire"/>

    <PolicyGroupsManager
      v-model="showGroupsModal"
      :groups="policyGroups"
      @create-group="handleCreateGroup"
      @update-group="handleUpdateGroup"
      @delete-group="handleDeleteGroup"
    />

    <div class="mt-5 pt-4">
      <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Policies</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Policy Library</li>
        </ol>
      </nav>

			<div class="mt-4">
				<div class="row">
					<div class="col-md-12">
            <div class="card shadow p-3 mb-5 bg-white rounded border-0">
              <div class="card-body m-2">
                <div class="row p-2">
                  <div class="row align-items-center">
                    <div class="col-6 col-md-6 col-xl-3">
                      <div class="input-group">
                          <input type="text" class="form-control" placeholder="Search Policies..." aria-label="Username" v-model="search" aria-describedby="search" style="box-sizing: border-box; width: 331px; height: 40px; border: 1px solid #D9D9D9; border-radius: 20px; padding-left: 40px; z-index: 0;">
                          <span class="input-group-addon" style="position: absolute; left: 20px; top: 50%; transform: translateY(-50%); background-color: white;">
                            <i class="fas fa-search"></i>
                          </span>
                        </div>
                    </div>
                    <div class="col-6 col-md-6 col-xl-3 col-xxl-4 mt-2 mb-2 d-flex">
                      <button v-if="isAdmin || isSuperAdmin || isPolicyOwner || isPolicyAdmin" type="button" class="btn btn-primary btn-create" @click="openPolicy" data-bs-placement="top">Add New Policy</button>
                      <button v-if="hasGroupAccess" type="button" class="btn btn-primary btn-create ms-2" @click="showGroupsModal = true">Policy Groups</button>
                    </div>

                    <div class="filter-options-wrapper col-12 col-xl-12 col-xxl-5 d-flex mt-2 mb-2">
                      <div class="d-flex flex-row align-items-center">
                        <span class="p-2 filter-title">
                          <i class="filter-icon fa-solid fa-sort"></i>
                          <span class="filter-text"> Sort </span>
                        </span>
                        <select v-model="selectedSort" class="form-select shadow-none filter-options" style="width:auto;border:none">
                          <option v-for="sortOption in sortByList" :value="sortOption.value" :key="sortOption.value">{{ sortOption.text }}</option>
                        </select>
                      </div>
                      <div class="d-flex flex-row align-items-center">
                        <span class="p-2 filter-title">
                            <i class="filter-icon fa-solid fa-list-ol"></i>
                            <span class="filter-text"> Items per page </span>
                        </span>
                        <select v-model="mainTablePagination.pageSize" class="form-select form-select-sm shadow-none filter-options">
                            <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text }}</option>
                        </select>
                      </div>
                      <div class="d-flex flex-row align-items-center p-1 ms-2">
                        <div class="align-middle col-xs-12">
                          <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                <div class="container mt-5">
                  <!-- <div v-if="loading" class="text-center p-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div> -->
                  <template v-for="(row, rowIndex) in chunkedGroups" :key="rowIndex">
                    <div class="row">
                      <div class="col-12 col-lg-6 col-xl-3 mb-4" v-for="group in row" :key="group.ID">
                        <PolicyGroupCard
                          :group-name="group.name"
                          :match-count="group.match_count"
                          :description="group.description"
                          :is-active="activeGroupName === group.name"
                          @toggle="handleToggle(group.name)"
                        />
                      </div>
                    </div>

                    <Transition name="slide-fade">
                      <div class="row" v-if="isRowActive(row)">
                        <div class="col-12">
                          <div class="expanded-panel mb-4">
                            <PolicyLibraryTable
                              :loading="isLoading"
                              :policies="activePolicies"
                              :users="users"
                              :videoIDs="videoIDs"
                              :loading-policy-ids="loadingPolicyIds"
                              :pagination="activeGroupPagination"
                              @page-change="handleActiveGroupPageChange"
                              @review="selectReviewedPolicy"
                              @edit="onButtonClick"
                              @set-owner="setPolicyOwner"
                              @set-requirement="setRequirement"
                              @set-training-link="policyStatusChange($event.policy.ID, $event.videoId)"
                              @archive="handleArchiveChange"
                              @view-file="handleLinkClick"
                              @remind="sendOverdueReminder"
                              @delete="onDelete"
                            />
                          </div>
                        </div>
                      </div>
                    </Transition>
                  </template>
                </div>
                <!-- Show ungrouped policies only if there are any -->
                <div v-if="!loading && policies.length > 0">
                  <h4 class="mt-5 mb-3 text-default">Ungrouped Policies</h4>
                  <PolicyLibraryTable
                    :policies="policies"
                    :users="users"
                    :videoIDs="videoIDs"
                    :show-no-policies-message="false"
                    :loading-policy-ids="loadingPolicyIds"
                    :pagination="mainTablePagination"
                    @page-change="handleMainTablePageChange"
                    @review="selectReviewedPolicy"
                    @edit="onButtonClick"
                    @set-owner="setPolicyOwner"
                    @set-requirement="setRequirement"
                    @set-training-link="policyStatusChange($event.policy.ID, $event.videoId)"
                    @archive="handleArchiveChange"
                    @view-file="handleLinkClick"
                    @remind="sendOverdueReminder"
                    @delete="onDelete"
                  />
                </div>
                </div>
                <div class="row mt-2">
                  <div v-if="loading" class="text-center align-middle">
                    <img src="@/assets/img/loading.svg">
                  </div>
                </div>
              </div>
            </div>
					</div>
				</div>
			</div>
    </div>
  </div>
  <div class="offcanvas offcanvas-end" tabindex="-1" id="evidenceSidebar" aria-labelledby="evidenceSidebar"
      ref="evidenceSidebarRef">
      <div class="offcanvas-body p-4">
         <PolicyForm
            ref="policyFormComponent"
            :data="editPolicy"
            :videoIDs="videoIDs"
            v-if="isOffcanvasOpen"
            :users="users"
            :can-create-group="hasGroupAccess"
            :groups="policyGroups"  @onUpdate="updatePolicy"
            @onCancel="handleCancelPolicyEdit"
            @onCancelRevert="handleCancelRevert"
            @onClickReview="setReviewPolicyCanvas"
            @create-group-request="handleCreateGroup" />
      </div>
  </div>
</template>

<script>
import moment from "moment";
import { Offcanvas } from 'bootstrap';
import Delete from '@/components/Delete.vue';
import { debounce } from '@/plugins/helper.js'
import Policy from '@/components/policies/Policy.vue';
import PolicyForm from '@/components/policies/PolicyForm.vue';
import PolicyReview from '@/components/policies/PolicyReview.vue';
import PolicyRequire from '@/components/policies/PolicyRequire.vue';
import PolicyGroupCard from '@/components/policies/PolicyGroupCard.vue';
import PolicyLibraryTable from '@/components/policies/PolicyLibraryTable.vue';
import PolicyGroupsManager from '@/components/policies/PolicyGroupsManager.vue';

export default{
  name: "PolicyLibrary",
  components: {
    Policy,
    Delete,
    PolicyForm,
    PolicyReview,
    PolicyRequire,
    PolicyGroupCard,
    PolicyLibraryTable,
    PolicyGroupsManager,
  },
  data(){
    return {
      loading: false,
      loadingPolicyIds: new Set(),
      isEditing: false,
      onDeleteDialog: false,
      deleteID: 0,
      onAttest: false,
      attestItem: [],
      isAttested: false,
      editedPolicy: null,
      isOffcanvasOpen: false,
      offcanvasInstance: null,
      sidebarListenerAdded: false,
      showPolicyReview: false,
      reviewedPolicy: null,
      showRequiredPopup: false,
      showArchived: false,
      policyCount: 0,
      search: '',
      policies: [],
      setForm: false,
      videoIDs: [],
      videos: [],
      users: [],
      orgID: this.$helper.setOrganisationID(),
      isAdmin: false,
      isSuperAdmin: this.$store.state.auth.isSuperAdmin,
      isPolicyAdmin: this.$store.state.auth.isPolicyAdmin,
      policyID: null,
      mainTablePagination: {
        pageSize: 10,
        page: 1,
        totalItems: 0,
        totalPages: 1,
      },
      activeGroupPagination: {
        pageSize: 10,
        page: 1,
        totalItems: 0,
        totalPages: 1,
      },
      rowsPerPageList: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "20", value: 20 },
      ],
      sortBy: {
        field: "name",
        order: "asc"
      },
      sortByList: [
        { text: "Name: A-Z", value: "name_asc", show: true },
        { text: "Name: Z-A", value: "name_desc", show: true},
        { text: "Date Created: Newest", value: "created_desc", show: true },
        { text: "Date Created: Oldest", value: "created_asc", show: true },
      ],
      activeGroupName: null,
      activePolicies: [],
      isLoading: false,
      policyGroups: [],
      showGroupsModal: false,
      searchResults: [],
      activeGroupAbortController: null,
    }
  },
  async created(){
    if (this.$helper.isVertexAnalyst()) {
      this.orgID  = this.$store.state.auth.jwtPayload.organisation_role[0].organisation_id
    }
    this.isAdmin = this.$helper.settingsAdmin();
    this.sortByList = this.filteredSortByList
    await this.init();
  },
  mounted() {
    this.offcanvasInstance = new Offcanvas(this.$refs.evidenceSidebarRef);
    this.onToggleSidebar()
  },
  methods: {
    async searchPolicyGroups() {
      if (!this.search) {
        this.searchResults = [];
        this.getPolicyGroups(); // Re-fetch all groups when search is cleared
        return;
      }
      try {
        const userID = this.$store.state.auth.jwtPayload.user_id;
        const params = {
          keyword: this.search,
          userID: userID,
        };

        const response = await this.$axios.get(`/orgadmin/trainings/organisations/${this.orgID}/training-policy/search-groups`, { params });
        if (response.data.success) {
          this.searchResults = response.data.search_results || [];
          // If there are search results, automatically open the first group.
          if (this.searchResults.length > 0) {
            const firstGroup = this.searchResults[0];
            this.activeGroupName = firstGroup.group_name;
            this.fetchPoliciesForGroup(this.activeGroupName);
          }
        }
      } catch (error) {
        console.error("Error searching policy groups:", error);
      }
    },
    async getPolicyGroups() {
      try {
        const response = await this.$axios.get(`/orgadmin/trainings/organisations/${this.orgID}/training-policy/group`);
        if (response.data.success) {
          this.policyGroups = response.data.policy_groups || [];
        } else {
          this.$toast.error("Could not fetch policy groups.");
        }
      } catch (error) {
        console.error("Error fetching policy groups:", error);
        this.$toast.error("An error occurred while fetching policy groups.");
      }
    },

    isRowActive(row) {
      if (!this.activeGroupName) return false;
      return row.some(group => group.name === this.activeGroupName);
    },

    handleToggle(groupName) {
      // If there's a pending request for a group, cancel it.
      if (this.activeGroupAbortController) {
        this.activeGroupAbortController.abort();
        this.activeGroupAbortController = null;
      }
      if (this.activeGroupName === groupName) {
        this.activeGroupName = null;
      } else {
        this.activeGroupName = groupName;
        this.activeGroupPagination.page = 1;
        this.fetchPoliciesForGroup(groupName);
      }
    },

    async fetchPoliciesForGroup(groupName) {
      this.isLoading = true;
      this.activePolicies = [];

      // Create a new AbortController for this request
      this.activeGroupAbortController = new AbortController();
      const signal = this.activeGroupAbortController.signal;

      try {
        const group = this.policyGroups.find(g => g.name === groupName);
        if (!group) throw new Error("Group not found");

        const params = {
            page: this.activeGroupPagination.page,
            limit: this.activeGroupPagination.pageSize,
            filter: this.search,
            sort: this.sortBy.field,
            order: this.sortBy.order,
        };

        const userID = this.$store.state.auth.jwtPayload.user_id;
        const url = `/orgadmin/trainings/organisations/${this.orgID}/users/${userID}/training-policy/group/${group.ID}`;

        const response = await this.$axios.get(url, { params, signal });

        if (response.data.success) {
          // Assuming the API returns an array under a 'policies' or 'training_policies' key and a total count. Adjust if needed.
          this.activePolicies = response.data.training_policies || [];
          this.activeGroupPagination.totalItems = response.data.total;
          this.activeGroupPagination.totalPages = Math.ceil(response.data.total / this.activeGroupPagination.pageSize);
        } else {
          this.$toast.error("Could not fetch policies for this group.");
        }
      } catch (error) {
        console.error('Request for group policies was canceled.');
      } finally {
        this.isLoading = false;
        this.activeGroupAbortController = null;
      }
    },

    async getData() {
      let params = {
        filter: this.search,
        sort: this.sortBy.field,
        order: this.sortBy.order,
        limit: this.mainTablePagination.pageSize,
        page: this.mainTablePagination.page
      };

      try {
        const url = `/orgadmin/trainings/organisations/${this.orgID}/users/${this.$store.state.auth.jwtPayload.user_id}/training-policy`;
        const response = await this.$axios.get(url, { params });
        if (response.data.success) {
          this.policies = response.data.training_policies || [];
          this.policyCount = this.policies.length;
          this.mainTablePagination.totalItems = response.data.total;
          this.mainTablePagination.totalPages = Math.ceil(this.mainTablePagination.totalItems / this.mainTablePagination.pageSize);
        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        this.$store.commit('user/setIsPolicyOwner', false);
        this.$router.push({ path: `compliance` });
        return;
      }

      this.isEditing = false;
    },

    setReviewPolicyCanvas(val){
      this.isOffcanvasOpen = false;
      this.offcanvasInstance.hide();

      this.showPolicyReview = true
      this.reviewedPolicy = val.data
    },


    handleMainTablePageChange(newPage) {
      if (newPage > 0 && newPage <= this.mainTablePagination.totalPages) {
        this.mainTablePagination.page = newPage;
        this.refreshAllData();
      }
    },

    handleActiveGroupPageChange(newPage) {
      if (newPage > 0 && newPage <= this.activeGroupPagination.totalPages) {
        this.activeGroupPagination.page = newPage;
        this.fetchPoliciesForGroup(this.activeGroupName);
      }
    },

    async init() {
      await this.getUsers();
      await this.refreshAllData();
      await this.getOrganisationVideos();
      await  this.getPolicyGroups();
      this.clearInvalidTrainingVideos();
    },

    async getUsers() {
      try {
        const response = await this.$axios.get('/users/organisations/' + this.orgID);
        if (response.data.success) {
          this.users = response.data.users.sort((a, b) => {
            if (a.first_name.toLowerCase() < b.first_name.toLowerCase()) return -1;
            if (a.first_name.toLowerCase() > b.first_name.toLowerCase()) return 1;
            return 0;
          });
        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        this.$toast.error("There was an error fetching the users.");
      }
    },
    onToggleSidebar() {
      const offcanvasElement = this.$refs.evidenceSidebarRef;
      if (offcanvasElement && !this.sidebarListenerAdded) {
        offcanvasElement.addEventListener('hidden.bs.offcanvas', () => {
          this.closeOffcanvas();
        });
        this.sidebarListenerAdded = true;
      }
    },
    async getOrganisationVideos() {
      try {
        let url = '/trainings/organisations/' + this.orgID + '/videos';
        const response = await this.$axios.get(url);
        if (response.data.success) {
          this.videos = response.data.assigned_org_videos;
          this.mapVideosToDropdown();
        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        this.$toast.error('An error occurred while fetching data.');
      }
    },
    mapVideosToDropdown() {
      this.videoIDs = this.videos
      .filter(video => video.is_active)
      .map(video => ({
          label: video.training_video.name,
          value: video.training_video_id
        }));
      },
    clearInvalidTrainingVideos() {
      if (!this.policies) return;
      this.loading = true
      const validVideoIDs = new Set(this.videoIDs.map(video => video.value));
      this.policies.forEach(policy => {
        if (!validVideoIDs.has(policy.training_video_id)) {
          policy.training_videos = [];
        }
      });
      this.loading = false
    },

    onButtonClick(policy) {
      const policyCopy = JSON.parse(JSON.stringify(policy));
      this.openOffcanvas(policyCopy);
    },

    openOffcanvas(policy) {
      this.editPolicy = policy;
      // Create a pristine copy for cancellation purposes
      this.pristineEditPolicy = JSON.parse(JSON.stringify(policy));
      this.isOffcanvasOpen = true;
      this.offcanvasInstance.show();
    },

    closeOffcanvas() {
      this.editPolicy = null;
      this.pristineEditPolicy = null;
      this.isOffcanvasOpen = false;
      this.offcanvasInstance.hide();
      // Explicitly reset the form component's internal state
      if (this.$refs.policyFormComponent) {
        this.$refs.policyFormComponent.resetComponentState();
      }
    },
    handleCancelRevert() {
      // Re-fetch the original policy from the list and create a fresh deep copy.
      const sourceList = this.activeGroupName ? this.activePolicies : this.policies;
      const originalPolicy = sourceList.find(p => p.ID === this.editPolicy.ID);
      if (originalPolicy) {
        this.editPolicy = JSON.parse(JSON.stringify(originalPolicy));
      }
      // Explicitly reset the form component's internal state after reverting
      // This ensures the `isModified` computed property is correct
      if (this.$refs.policyFormComponent) {
        this.$refs.policyFormComponent.resetComponentState();
      }
    },

    handleCancelPolicyEdit() {
      // When cancel is clicked in the form, we don't need to do anything
      // but close the offcanvas. The form handles reverting its own state.
      this.closeOffcanvas();
    },
    setRequirement(policy) {
      if (policy.required) {
        this.reviewedPolicy = policy
        this.showRequiredPopup = true
      } else {
        this.saveRequirement(policy, false)
      }
    },
    async setPolicyOwner({ policy, ownerId }) {
      if (policy.archived) {
        this.$toast.info("Archived policies cannot be modified.");
        this.refreshAllData();
        return;
      }
      this.isEditing = true;
      let data = { "owner": parseInt(ownerId) };
      try {
        const response = await this.$axios.put("/orgadmin/trainings/organisations/" + this.orgID + "/training-policy" + "/" + policy.ID + "/owner", data);
        if (response.data.success) {
          this.$toast.success(response.data.message);

          // First, re-check ownership status from the server.
          await this.$store.dispatch('user/determinePolicyOwner');

          // Now, check the updated state from Vuex.
          if (this.isPolicyOwner || this.isPolicyAdmin || this.$store.state.auth.isOrganisationAdmin) {
          this.refreshAllData();
          } else {
            this.$router.push({ path: `compliance` });
          }
        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error updating policy:", error);
      }
    },
    async policyStatusChange(policyID, trainingVideoID) {
      this.isEditing = true;
      let data = {
        training_video_id: trainingVideoID,
      };
      try {
        const response = await this.$axios.put("/orgadmin/trainings/organisations/" + this.orgID + "/training-policy" + "/" + policyID + "/link", data);
        if (response.data.success) {
          this.$toast.success(response.data.message);
          this.refreshAllData();
        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error updating policy:", error);
      }
      this.policyID = null;
    },
    onDelete(policy){
      this.deleteID = policy.ID
      this.onDeleteDialog = true;
    },
    closeDelete() {
      this.deleteID = 0;
      this.onDeleteDialog = false;
    },

    async deleteConfirmation(data) {
      try {
        const response = await this.$axios.delete(`/orgadmin/trainings/organisations/${this.orgID}/training-policy/${data.id}`);

        if (response.data.success) {
          this.$toast.success(response.data.message);

          // Use the helper to refresh BOTH tables
          await this.refreshAllData();

        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error deleting policy:", error);
        this.$toast.error("An error occurred while deleting the policy.");
      } finally {
        // This code runs whether the API call succeeds or fails
        this.onDeleteDialog = false;
        this.deleteID = 0;
      }
    },

    async sendOverdueReminder(policy){
      this.loadingPolicyIds.add(policy.ID);
      if (!policy.required) {
        this.$toast.error("Policy is not required.")
      }
      await this.$axios.get("/orgadmin/trainings/organisations/"+ this.orgID +"/training-policy/"+policy.ID+"/remind-overdue")
        .then((response) => {
            if (response.data.success){
              this.$toast.success("Email reminder sent successfully.")
            } else {
              this.$toast.error(response.data.message)
            }
        })
        .catch()
      this.loadingPolicyIds.delete(policy.ID);
    },
    openPolicy() {
      this.setForm = true;
    },
    closePolicy(){
      this.setForm = false;
      this.editedPolicy = null;
    },
    handleLinkClick(item) {
      // If the policy is from Alke, redirect to the dedicated preview page.
      // if (item.from_alke) {
      //   this.$router.push({ name: 'PolicyPreview', params: { id: item.ID } });
      //   return;
      // }

      if (!item.pdf_exists) {
        if (this.isAdmin)
          this.$toast.warning("A new policy upload is required due to error with existing file.")
        else
          this.$toast.warning("A new policy upload is required due to error with existing file.")
        return
      }
      if (!item.link) {
        return
      }
      if (!item.link.includes("http")) {
        this.openLinkInNewTab("https://" + item.link);
      } else {
        this.openLinkInNewTab(item.link);
      }
    },
    openLinkInNewTab(link) {
      window.open(link, '_blank');
    },
    selectReviewedPolicy(policy){
      this.showPolicyReview = true
      this.reviewedPolicy = policy
    },
    closePolicyReview() {
      this.reviewedPolicy = null
      this.showPolicyReview = false
    },
    async setNextReviewDate(val){
      this.isEditing = true;
      let data = {
        review_date: val.data.next_review_date,
        notes: val.data.notes,
      };
      try {
        const response = await this.$axios.put("/orgadmin/trainings/organisations/" + this.orgID + "/training-policy" + "/" + val.data.policy_id + "/review-date", data);
        if (response.data.success) {
          this.$toast.success(response.data.message);
          this.refreshAllData();
        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error updating policy:", error);
      }
    },
    async uploadNewVersion(val){
      let formData = new FormData();
      if (val.data.type == "file"){

        let uploadedFile = val.data.file.files ? val.data.file.files[0] : val.data.file;
        if (uploadedFile && uploadedFile.name) {
          if (!uploadedFile.name.toLowerCase().endsWith(".pdf")) {
            this.$toast.error("Security Warning: Invalid file format. Only .pdf files are allowed.");
            return; // Instantly abort the request
          }
        }

        // Proceed with appending if safe
        formData.append('file', val.data.file.files || val.data.file);
      }
      else {
        if (val.data.link !== val.data.currLink) {
          formData.append('file', val.data.file);
        }
      }
      formData.append('training_video_id',  val.data.videoID);
      formData.append('required',  val.data.compulsory);
      formData.append('name',  val.data.name);
      formData.append('type',  val.data.type);
      formData.append('review_date', moment(val.data.review_date).utc().format());
      formData.append('notes',  val.data.notes);
      formData.append('enforce',  val.data.enforce);
      try {
        const response = await this.$axios.put("/orgadmin/trainings/organisations/" + this.orgID + "/training-policy" + "/" + val.data.id + "/new-version", formData);
        if (response.data.success) {
          this.$toast.success(response.data.message);
          this.refreshAllData();
        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error updating policy:", error);
      }
    },
    preparePolicyRequire(policy){
      let data = {
        ID: policy.id,
        required: policy.required,
      }
      this.saveRequirement(data, policy.notify)
    },
    closePolicyRequire(){
      this.reviewedPolicy = null;
      this.showRequiredPopup = false;
    },
    async saveRequirement(policy, notify) {
      this.isEditing = true;
      let data = {
        required: policy.required,
      };
      try {
        const response = await this.$axios.put("/orgadmin/trainings/organisations/" + this.orgID + "/training-policy" + "/" + policy.ID + "/requirement"+"?notify="+notify, data);
        if (response.data.success) {
          this.$toast.success(response.data.message);
          this.refreshAllData();
        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error updating policy:", error);
      }
    },
    async handleArchiveChange({ policy, archived }) {
      this.isEditing = true;
      let data = {
        archived: archived,
      };
      try {
        const response = await this.$axios.put(`/orgadmin/trainings/organisations/${this.orgID}/training-policy/${policy.ID}/archive`, data);

        if (response.data.success) {
          // Find the policy in the main list by its ID
          const mainIndex = this.policies.findIndex(p => p.ID === policy.ID);
          if (mainIndex !== -1) {
            // Update its 'archived' property directly
            this.policies[mainIndex].archived = archived;
          }

          // Do the same for the activePolicies list, if it's open
          const activeIndex = this.activePolicies.findIndex(p => p.ID === policy.ID);
          if (activeIndex !== -1) {
            this.activePolicies[activeIndex].archived = archived;
          }

          let message = "Policy has been successfully archived."
          if (!archived) {
            message = "Policy has been successfully un-archived."
          }
          this.$toast.success(message);

        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error archiving policy:", error);
      }
    },

    async refreshAllData() {
      // Determine if a group panel is open to show the correct spinner
      const isGroupOpen = !!this.activeGroupName;

      if (isGroupOpen) {
        this.isLoading = true; // Turn on the group panel spinner
      } else {
        this.loading = true; // Turn on the main table spinner
      }

      try {
        // Create promises for both data fetches
        const mainDataPromise = this.getData();
        const groupDataPromise = isGroupOpen ? this.fetchPoliciesForGroup(this.activeGroupName) : Promise.resolve();

        // Wait for both to complete at the same time
        await Promise.all([mainDataPromise, groupDataPromise]);

      } catch (error) {
        console.error("Data refresh failed:", error);
        this.$toast.error("Failed to refresh data.");
      } finally {
        // Turn off both spinners when everything is finished
        this.isLoading = false;
        this.loading = false;
      }
    },
    async updatePolicy(val) {

      let formData = new FormData();

      if (val.data.type == "file"){

        let uploadedFile = val.data.file.files ? val.data.file.files[0] : val.data.file;
        if (uploadedFile && uploadedFile.name) {
          if (!uploadedFile.name.toLowerCase().endsWith(".pdf")) {
            this.$toast.error("Security Warning: Invalid file format. Only .pdf files are allowed.");
            return; // Instantly abort the request
          }
        }

        // Proceed with appending if safe
        formData.append('file', val.data.file.files || val.data.file);
      }
      else {
        if (val.data.link !== val.data.currLink) {
          formData.append('file', val.data.file);
        }
      }

      formData.append('training_video_id',  val.data.videoID);
      formData.append('required',  val.data.compulsory);
      formData.append('name',  val.data.name);
      formData.append('type',  val.data.type);
      formData.append('owner',  val.data.owner);

      if (val.data.policy_group_id > -1) {
        formData.append('policy_group_id', val.data.policy_group_id);
      }

      await this.$axios.put("/orgadmin/trainings/organisations/"+ this.orgID +"/training-policy/"+ val.data.id, formData)
        .then((response) => {
            if (response.data.success){
              this.$toast.success(response.data.message)
              this.refreshAllData();
            } else {
              this.$toast.error(response.data.message)
            }
        })
        .catch()

      this.closeOffcanvas();
      new Offcanvas(this.$refs.evidenceSidebarRef).hide();
    },

    async createPolicy(val){

      let formData = new FormData();

      if (val.data.type == "file"){

        let uploadedFile = val.data.file.files ? val.data.file.files[0] : val.data.file;
        if (uploadedFile && uploadedFile.name) {
          if (!uploadedFile.name.toLowerCase().endsWith(".pdf")) {
            this.$toast.error("Security Warning: Invalid file format. Only .pdf files are allowed.");
            return; // Instantly abort the request
          }
        }

        formData.append('file', val.data.file.files || val.data.file);
      }
      else {
        if (val.data.link !== val.data.currLink) {
          formData.append('file', val.data.file);
        }
      }

      if (this.isPolicyOwner && !this.isSuperAdmin || this.$store.state.user.organisation.is_organisation_admin || this.isPolicyAdmin){
        formData.append('owner', this.$store.state.auth.jwtPayload.user_id);
      }

      formData.append('training_video_id',  val.data.videoID);
      formData.append('required',  val.data.compulsory);
      formData.append('name',  val.data.name);
      formData.append('type',  val.data.type);

      if (val.data.policy_group_id) {
        formData.append('policy_group_id', val.data.policy_group_id);
      }

      await this.$axios.post("/orgadmin/trainings/organisations/"+ this.orgID +"/training-policy", formData)
      .then((response) => {
          if (response.data.success){
            this.$toast.success(response.data.message)
            this.refreshAllData();
          } else {
            this.$toast.error(response.data.message)
          }
      })
      .catch()
    },

    async handleCreateGroup(newGroupData) {
      try {
        const response = await this.$axios.post(`/orgadmin/trainings/organisations/${this.orgID}/training-policy/group`, newGroupData);
        if (response.data.success) {
          this.$toast.success(`Group "${newGroupData.name}" created successfully.`);
          await this.getPolicyGroups();

          // Find the newly created group in the updated list.
          const newGroup = this.policyGroups.find(g => g.name === newGroupData.name);

          if (newGroup) {
            // If the offcanvas (edit form) is open, update its policy object.
            if (this.isOffcanvasOpen && this.editPolicy) {
              this.editPolicy.policy_group_id = newGroup.ID;
            }
          }
        } else {
          this.$toast.error(response.data.message || "Failed to create group.");
        }
      } catch (error) {
        console.error("Error creating policy group:", error);
        this.$toast.error("An error occurred while creating the group.");
      }
    },

    async handleUpdateGroup(updatedGroupData) {
      try {
        const response = await this.$axios.put(`/orgadmin/trainings/organisations/${this.orgID}/training-policy/group/${updatedGroupData.ID}`, updatedGroupData);
        if (response.data.success) {
          this.$toast.success(`Group "${updatedGroupData.name}" updated successfully.`);

          // MODIFIED: Refetch the entire list to ensure data consistency.
          await this.getPolicyGroups();

        } else {
          this.$toast.error(response.data.message || "Failed to update group.");
        }
      } catch (error) {
        console.error("Error updating policy group:", error);
        this.$toast.error("An error occurred while updating the group.");
      }
    },

    async handleDeleteGroup(groupId) {
      try {
        const response = await this.$axios.delete(`/orgadmin/trainings/organisations/${this.orgID}/training-policy/group/${groupId}`);
        if (response.data.success) {
          this.$toast.success(`Group deleted successfully.`);

          this.activeGroupName = null;

          // MODIFIED: Refetch the entire list to ensure data consistency.
          await this.getPolicyGroups();
          await this.refreshAllData();

        } else {
          this.$toast.error(response.data.message || "Failed to delete group.");
        }
      } catch (error) {
        console.error("Error deleting policy group:", error);
        this.$toast.error("An error occurred while deleting the group.");
      }
    },


  },
  computed: {
    organisation() {
      return this.$store.state.auth.isSuperAdmin ? this.$store.state.user.organisation.name : this.$store.state.user.organisation.organisation;
    },
    selectedSort: {
      get() {
        return this.sortBy.field + '_' + this.sortBy.order;
      },
      set(value) {
        const [field, order] = value.split('_');
        this.sortBy = { field, order };
      }
    },
    sortItems() {
      return this.sortBy
    },
    filteredSortByList() {
      return this.sortByList.filter(option => {
        if ((option.value === 'attested_desc' || option.value === 'attested_asc') && this.isSuperAdmin) {
          return false;
        }
        return option.show;
      });
    },
    isPolicyOwner() {
      return this.$store.getters['user/isPolicyOwner'];
    },
    hasGroupAccess() {
      return this.$store.state.auth.isPolicyAdmin || this.isSuperAdmin || this.$store.state.auth.isOrganisationAdmin;
    },
    chunkedGroups() { // This computed property determines which groups to display
      const chunkSize = 4;
      const result = [];
      // If a search is active, use the searchResults. Otherwise, use the full list of policyGroups.
      let source = this.policyGroups;
      if (this.search) {
        source = this.searchResults.map(searchResult => {
          const originalGroup = this.policyGroups.find(pg => pg.ID === searchResult.group_id);
          return { ...searchResult, ID: searchResult.group_id, name: searchResult.group_name, description: originalGroup ? originalGroup.description : '' };
        });
      }

      for (let i = 0; i < source.length; i += chunkSize) {
        result.push(source.slice(i, i + chunkSize));
      }
      return result;
    },
  },
  watch: {
    search: debounce(function() {
      this.policies = []
      this.mainTablePagination.page = 1;
      this.activeGroupPagination.page = 1;
      if (this.search) {
        this.searchPolicyGroups();
        this.getData(); // Fetch ungrouped policies with the search filter
        if (this.activeGroupName) {
          this.fetchPoliciesForGroup(this.activeGroupName);
        }
      } else {
        this.activeGroupName = null;
        this.searchResults = [];
        this.refreshAllData();
      }
    }, 600),
    organisation(){
      if (this.$store.state.auth.accessToken == null) return
      this.orgID = this.$store.state.user.organisation.id
      this.init();
    },
    sortItems() {
      this.init();
    },
    'mainTablePagination.pageSize'() {
      this.mainTablePagination.page = 1;
      // Sync the group pagination size as well
      this.activeGroupPagination.pageSize = this.mainTablePagination.pageSize;
      this.refreshAllData();
    },
  }
}
</script>


<style scoped>
.form-control{
  -webkit-border-radius: 0px;
     -moz-border-radius: 20px;
          border-radius: 20px;
}
.btn-create {
  -webkit-border-radius: 20px;
     -moz-border-radius: 20px;
          border-radius: 20px;
  font-size:13px;
  font-weight: 900;
  padding-right: 15px;
  padding-left: 15px;
  margin-bottom: 0px;
}

.btn-square {
  -webkit-border-radius: 0px;
     -moz-border-radius: 0px;
          border-radius: 0px;
  border:1px solid #00A0C1;
}

::-webkit-input-placeholder {
   font-size: 14px!important;
}

:-moz-placeholder { /* Firefox 18- */
      font-size: 14px!important;
}
::-moz-placeholder {  /* Firefox 19+ */
      font-size: 14px!important;
}

/* Container holding the image and the text */
.container {
  position: relative;
  text-align: center;
  color: white;
}
.styled-checkbox {
    position: relative;
    width: 25px;
    height: 25px;
  }

  .styled-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .styled-checkbox label {
    position: absolute;
    top: 0;
    left: 0;
    width: 25px;
    height: 25px;
    background-color: transparent;
    border: 2px solid #6c757d;
    border-radius: 1px;
  }

  .styled-checkbox input:checked + label {
    border-color: #198754;
  }

  .styled-checkbox input:checked + label::before {
    content: '\2713'; /* Unicode checkmark character */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    color: #198754;
    font-weight: bold;
  }

  .table-select {
   padding-left: 5px;
   margin-right: 0;
   cursor: pointer;
   border: none;
   height: 45px;
   width: auto;
  }

  .table-select:not(.high, .low, .medium) {
    color: #435666;
  }

  .table-select>option{
    color: #212529;
  }

  .table-select:not(:hover) {
    background: none;
  }

  /* attest button */
  .custom-icon-btn {
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 50%;
  }

  .custom-icon-btn svg {
    width: 18px;
    height: 18px;
  }

  .btn-circle-inactive{
  color: #bebebe;
  width: 30px;
	height: 30px;
	padding: 6px 0px;
	border-radius: 15px;
	text-align: center;
	font-size: 12px;
	line-height: 1.42857;
	border: 1px solid #bebebe;
}

.btn-circle-active{
  color: #00B972;
  width: 30px;
	height: 30px;
	padding: 6px 0px;
	border-radius: 15px;
	text-align: center;
	font-size: 12px;
	line-height: 1.42857;
	border: 1px solid #00B972;
}
.btn-circle-pending{
  color: #ffc107;
  width: 30px;
	height: 30px;
	padding: 6px 0px;
	border-radius: 15px;
	text-align: center;
	font-size: 12px;
	line-height: 1.42857;
	border: 1px solid #ffc107;
}

/* attest button */


/* Bottom right text */
.overlay-top {
  background:#605f5f77;
  position: absolute;
  top: 0%;
  width:100%;
  height:20%;
  font-size:14px;
  overflow:visible;
}

/* Additional styling for the warning icon */
.warning-icon {
  position: absolute;
  top: 0;
  right: 0;
  background: orange;
  color: white;
  border-radius: 50%;
  padding: 0.2rem;
  font-size: 0.8rem;
}

/* Optional: Position the warning icon to make it look like a badge */
.btn {
  position: relative;
}

/* Optional: Adjust spacing and size as needed */
.btn-circle {
  padding: 0.5rem;
  border-radius: 50%;
}

.custom-icon-btn i {
  font-size: 1.5rem;
}

/* policy status tags */
.policy--current {
   background-color: #00A54F;
   color: #fff;
}

.policy--review_required {
  background-color: #F3994D;
  color: #fff;
}

.policy--review_overdue {
background-color: #EB1C24;
color: #fff;
}

.policy-badge {
  width: 127px;
  text-align: center;
  display: inline-block;
  height: 24px;
  font-size: 13px;
  font-weight: 900;
}

.expanded-panel {
  background: #FFFFFF;
  border: 1px solid #F5F5F5;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  padding: 1rem;
}

/* 2. ADDED THESE STYLES FOR THE SLIDE-FADE ANIMATION */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: max-height 0.35s ease-in-out, opacity 0.35s ease-in-out;
  overflow: hidden;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  max-height: 1000px; /* A value larger than the content will ever be */
  opacity: 1;
}
</style>